export const DRYBOX_FIELD_LABELS = {
  vin: { car: 'OrderCurrent.VIN', dry: 'DryBox.order_number' },
  make: { car: 'OrderCurrent.modal.carInfo.make', dry: 'DryBox.length' },
  model: { car: 'OrderCurrent.modal.carInfo.model', dry: 'DryBox.width' },
  trim: { car: 'OrderCurrent.modal.carInfo.trim', dry: 'DryBox.height' },
  year: { car: 'OrderCurrent.modal.carInfo.year', dry: 'DryBox.qty' },
  realWeight: { car: 'OrderCurrent.modal.carInfo.weight', dry: 'DryBox.unit_weight' },
  weight: { car: 'OrderInfo.information.weight', dry: 'DryBox.line_weight' },
  linearFeet: { car: null, dry: 'DryBox.linear_feet' }
}

export const dryBoxMixin = {
  computed: {
    isDryBox () {
      return !!(this.$store.state.userInfo && this.$store.state.userInfo.isDryBox)
    }
  },
  methods: {
    fieldLabel (type, fallback) {
      const entry = DRYBOX_FIELD_LABELS[type]
      if (!entry) return fallback !== undefined ? fallback : ''
      const dry = !!(this.$store.state.userInfo && this.$store.state.userInfo.isDryBox)
      if (dry && entry.dry) return this.$t(entry.dry)
      if (entry.car) return this.$t(entry.car)
      return fallback !== undefined ? fallback : ''
    },
    fieldLabelFor (order, type, fallback) {
      const entry = DRYBOX_FIELD_LABELS[type]
      if (!entry) return fallback !== undefined ? fallback : ''
      if (this.isPalletOrder(order) && entry.dry) return this.$t(entry.dry)
      if (entry.car) return this.$t(entry.car)
      return fallback !== undefined ? fallback : ''
    },
    isPalletOrder (order) {
      return !!(order && order.isDryBoxOrder)
    },
    palletDims (order) {
      return `${order.make || '?'}×${order.model || '?'}×${order.trim || '?'} in`
    },
    palletSummary (order) {
      return `${this.palletDims(order)} × ${order.year || 1}`
    }
  }
}
